import { render, staticRenderFns } from "./SettlementSalaryAdvance.vue?vue&type=template&id=2f126dec&"
import script from "./SettlementSalaryAdvance.vue?vue&type=script&lang=js&"
export * from "./SettlementSalaryAdvance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports